import React from 'react';
import Configurator from './Configurator.jsx';
import Button from "./ui/button/Button.jsx";
import Image from './ui/features/Image.jsx';
import styles from './PipeConfigurator.styl';
import Table from "./ui/features/Table.jsx";
import Switch from "./ui/features/InputSwitch.jsx";
import jQuery from "jquery";


class PipeConfigurator extends Configurator {

	//Конструктор
	constructor(props) {
		super(props);
		this.state = {
			//Списки
			bucketPipeList: [],
			cablesList: [],
			itemList: [], 										// Подобранные аксессуары
			pipeList: [],                     // Спецификация оборудования

			pipe: true,										// Выбрана труба
			flexPipe: false,											// Выбран металлорукав
			method: 'mark',
			onLoad: true,


			filterCable: 'Выбрать',
			cableOptions: ['Выбрать', 'ВВГнг(А)-LS-0,66',
				'ВВГнг(А)-LS-1',
				'ВВГнг(А)-LSLTx-0,66',
				'ВВГнг(А)-LSLTx-1',
				'ВВГнг(А)-FRLS-0,66',
				'ВВГнг(А)-FRLS-1',
				'ВВГнг(А)-FRLSLTx-0,66',
				'ВВГнг(А)-FRLSLTx-1',
				'ППГнг(А)-HF-0,66',
				'ППГнг(А)-HF-1',
				'ППГнг(А)-FRHF-0,66',
				'ППГнг(А)-FRHF-1',
				'ПуГВ'
			],

			inputDiam: 0,
			filterList: [
				{
					name: 'Материал',
					value: ['Все', 'ПВХ', 'ПНД'],
					selected: 'Все',
					show: true
				},
				{
					name: 'Тип',
					value: ['Все', 'Гофрированная', 'Гладкая'],
					selected: 'Все',
					show: true
				},
				{
					name: 'Цвет',
					value: [],
					selected: 'Все',
					show: true
				},
				{
					name: 'Тяжелая',
					selected: false,
					show: true
				},
				{
					name: 'С протяжкой',
					selected: false,
					show: true
				},
				{
					name: 'Двустенная',
					selected: false,
					show: true
				},
				{
					name: 'Жесткая',
					selected: false,
					show: true
				},


				{
					name: 'Разборная',
					selected: false,
					show: true
				},

				{
					name: 'Материал',
					value: ['Все', 'Сталь', 'Алюминий'],
					selected: 'Все',
					show: false
				},
				{
					name: 'Цвет',
					value: [],
					selected: 'Все',
					show: false
				},
				{
					name: 'В изоляции',
					selected: false,
					show: false
				},
				{
					name: 'С протяжкой',
					selected: false,
					show: false
				}
			]
		}

		//Кнопки
		this.doPrint = this.doPrint.bind(this);
		this.onBtnExcelClick = this.onBtnExcelClick.bind(this);
		this.onBtnAddCableClick = this.onBtnAddCableClick.bind(this)
		// Обработка событий таблиц
		this.onChangeQuantity = this.onChangeQuantity.bind(this);
		this.addBasket = this.addBasket.bind(this);
		this.onDelete = this.onDelete.bind(this);

		//Служебные процедуры функции

		this.onFlexPipeCheckChange = this.onFlexPipeCheckChange.bind(this);
		this.onPipeCheckChange = this.onPipeCheckChange.bind(this);

		this.onCableChange = this.onCableChange.bind(this);
		this.onSelectCable = this.onSelectCable.bind(this)

		this.calcTotalPrice = this.calcTotalPrice.bind(this);
		this.onFilterChange = this.onFilterChange.bind(this)
		this.onFilterPipeList = this.onFilterPipeList.bind(this)


	}


	// ++ Для Запуска

	getCustomStyles() {
		return styles;
	}

	getType() {
		return 'pipe';
	}

	componentDidMount() {
		this.onLoadPipeDB('05.02')
		this.onLoadCableDB()
	}

	// -- Для Запуска

	onLoadPipeDB(group) {
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'getItemListNSI',
				groupId: group
			},
			db => {

				const filter = ['труба ', 'металлорукав ', 'труба-', 'муфта']
				let productList = db.filter(i => {
					if (i.name !== null) {
						let name = i.name.toLowerCase()
						return (name.includes(filter[0]) || name.includes(filter[1])) && !name.includes(filter[2]) && !name.includes(filter[3])
					}
				})
				let newProductList = this.modifyProductList(productList, group)
				let filterList = this.modifyFilterList(newProductList, group)

				this.setState({productList: newProductList, onLoad: false, filterList})
			}
		);
	}

	modifyProductList(list, group) {
		let modifyProductList = []
		let filterList = []
		let attrList = []
		if (group === '05.02') {
			filterList = ['Материал_Name', 'Цвет_Name', 'протяжкой', 'Прочность на изгиб_Name', 'Внутр диаметр мм']
			attrList = ['material', 'color', 'cablePull', 'flexibility', 'diam']
		} else {
			filterList = ['Материал_Name', 'Цвет_Name', 'протяжкой', 'Материал обшивки 1-го покрытия_Name', 'Внутр диаметр мм']
			attrList = ['material', 'color', 'cablePull', 'isolation', 'diam']
		}
		list.map(i => {
			let obj = {}
			let length
			obj.article = i.Code
			obj.name = i.name

			if(i.name.includes('(')){
				length= i.name.split('(')
				length=length[1].split('м')
				obj.lengthPipe=length[0]
			}else {
				length=i['Features'].find(item => item['Attribute'].toLowerCase().includes('длина'))
				obj.lengthPipe=length.value/1000
			}

			filterList.map((elem, index) => {
				let id = i['Features'].findIndex(item => item['Attribute'].includes(elem))
				if (id !== -1) {
					obj[attrList[index]] = i['Features'][id].value
				} else {
					obj[attrList[index]] = '-'
				}
			})
			modifyProductList.push(obj)
		})
		return modifyProductList
	}

	modifyFilterList(list, group) {
		let filterList = this.state.filterList
		let id = 2
		if (group === '05.03') {
			id = 9
		}
		let arr = ['Все']
		list.map(elem => {
			if (arr.some(item => item == elem.color)) {
				return
			} else {
				arr.push(elem.color)
			}
		})
		filterList[id].value = arr

		return filterList

	}

	onLoadCableDB() {
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'get',
			},
			db => {
				this.db = db
			}
		);
	}

	//Отображение выбранного елемента
	onListItemCheck(item) {
		if (this.state.item && (item.article === this.state.item.article)) {
			return;
		}

		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'getItemNSI',
				article: item.article
			},
			items => {
				this.setState({item: items});
			}
		);
	}

	// -- Загрузка данных

	// Добавить элемент в корзину
	addBasket(item) {

		let elem = Object.assign({}, item)
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'getItemNSI',
				article: item.article
			},
			items => {
				this.setState((prevState) => {
					const bucketPipeList = [...prevState.bucketPipeList]
					let cablesList = [...prevState.itemList]
					if (bucketPipeList.some(i => {
						return i.article === elem.article && i.cableList.length === cablesList.length && i.cableList.every((it, id) => {
							return it.name === cablesList[id].name && it.selected === cablesList[id].selected &&
								it.count === cablesList[id].count
						})
					})) {
						bucketPipeList.map((i, id) => {
							if (i.article === elem.article && i.cableList.length === cablesList.length && i.cableList.every((it, idx) => {
								return it.name === cablesList[idx].name && it.selected === cablesList[idx].selected &&
									it.count === cablesList[idx].count
							})) {
								i.id = id
								i.price = items[0].price
								i.count += 1
								i.sum = Math.round(100 * i.count * i.price*i.lengthPipe) / 100
							}
							return i

						})
					} else {
						elem.id = bucketPipeList.length
						elem.cableList = cablesList
						elem.price = items[0].price
						elem.count = 1
						elem.sum = Math.round(100 * elem.count * elem.price*elem.lengthPipe) / 100
						bucketPipeList.push(elem)
					}
					return {bucketPipeList, itemList: [], pipeList: [], newPipeList: []}
				}, () => {
					this.doAddToCart(this.state.bucketPipeList)
					this.onListItemCheck(elem)
				});

			}
		);

	}

	//Удаление
	onDelete(item, type) {
		if (type === 'Cable') {
			this.setState((prevState) => {
				let newItemList = prevState.itemList.filter((el) => el.article !== item.article || el.id !== item.id)
				let itemList = newItemList.map((i, index) => {
					i.id = index
					return i
				})
				return {
					...prevState,
					itemList,

				}
			}, () => {
				this.calculatePipeSize()
			})
		} else {
			this.setState((prevState) => {
				let newBucketPipeList = prevState.bucketPipeList.filter((el) => el.article !== item.article || el.id !== item.id)
				 newBucketPipeList = newBucketPipeList.map((i, index) => {
					i.id = index
					return i
				})
				return {
					...prevState,
					bucketPipeList: newBucketPipeList,

				}
			}, () => {
				this.doAddToCart(this.state.bucketPipeList)
			})

		}
	}

	// изменение количества позиции
	onChangeQuantity(item, value, type) {
		if (type === 'Cable') {
			this.setState(prevState => {
				let newBasket = prevState.itemList.map(i => {
					if (i.name === item.name) {
						i.count = +value
						i.fullSize = Math.pow(i.diam, 2) * +value * 3.14 / 4
					}
					return i
				})
				return {
					itemList: newBasket
				}

			}, () => {
				this.calculatePipeSize()
			})
		} else {
			this.setState(prevState => {
				let newBasket = prevState.bucketPipeList.map(i => {
					if (i.article === item.article && i.marker === item.marker) {
						i.count = +value
						i.sum = i.price * i.count*i.lengthPipe
					}
					return i
				})
				return {
					bucketPipeList: newBasket
				}
			}, () => {
				this.doAddToCart(this.state.bucketPipeList)
			})
		}
	}

// -- Работа таблиц


	calcTotalPrice() {
		return this.state.bucketPipeList.reduce((sum, item) => Math.round(100 * (item.price * item.count* item.lengthPipe + sum)) / 100, 0)
	}

	// ++ Обработка событий

	onCableChange(event) {

		let value = event.target.value
		let cablesList = this.db.list.filter(item => item.name.trim() === value.trim())
		this.setState({filterCable: value, cablesList})

	}

	// ++ Чекбокс
	onFlexPipeCheckChange() {
		this.onLoadPipeDB('05.03')
		let filterList = this.state.filterList.map((i, id) => {
			if (id < 3 || id == 8 || id == 9) {
				i.selected = 'Все'
			} else {
				i.selected = false
			}
			return i
		})

		this.setState({
			onLoad: true,
			flexPipe: true,
			pipe: false,
			itemList: [],
			pipeList: [],
			newPipeList: [],
			method: 'mark',
			filterCable: 'Выбрать',
			filterList,
			inputDiam: 0
		})

	}

	onPipeCheckChange() {
		this.onLoadPipeDB('05.02')
		let filterList = this.state.filterList.map((i, id) => {
			if (id < 3 || id == 8 || id == 9) {
				i.selected = 'Все'
			} else {
				i.selected = false
			}
			return i
		})

		this.setState({
			itemList: [],
			pipeList: [],
			newPipeList: [],
			onLoad: true,
			flexPipe: false,
			pipe: true,
			method: 'mark',
			filterCable: 'Выбрать',
			filterList,
			inputDiam: 0
		})
	}

	// -- Чекбокс

	// ++Кнопки
	getCustomButtons() {
		let elements = [];

		elements.push(
			<Button
				x="838"
				y="764"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Сохранить в PDF"
				onClick={this.onBtnPrintPdfClick}
				key="printpdf"
			/>
		);

		elements.push(
			<Button
				x="533"
				y="764"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.printBtnIcon}
				text="Распечатать"
				onClick={this.onBtnPrintClick}
				key="print"
			/>
		);

		elements.push(
			<Button
				x="1144"
				y="764"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.excelBtnIcon}
				text="Сохранить в Excel"
				onClick={this.onBtnExcelClick}
				key="excel"
			/>
		);
		elements.push(
			<Button
				x="290"
				y="210"
				buttonStyle={styles.smallBtn}
				textStyle={styles.smallBtnText}
				iconStyle={styles.addCableBtnIcon}
				buttonDisabledStyle={styles.smallBtnDis}
				disabled={this.state.onLoad}
				text="Рассчитать"
				onClick={this.onBtnAddCableClick}
				key="cableButton"
			/>
		);

		return elements;
	}


	// ++ Обработка печати
	doPrint(params) {
		let _params = params || {};

		_params.data = {
			specList: JSON.stringify(this.state.bucketPipeList)
		};

		super.doPrint(_params);
	}

	onBtnExcelClick() {
		this.doPrint({format: 'xls'});
	}

	onBtnAddCableClick() {
		if (this.state.method === 'mark') {
			this.setState(prev => {
				if (this.state.filterCable !== 'Выбрать') {
					let filterSize = []
					this.state.cablesList.map(item => filterSize.push(item.size))
					let itemList = [...prev.itemList]
					let fullSize = Math.pow(+this.state.cablesList[0].diameter, 2) * 1 * 3.14 / 4
					let obj = {
						name: this.state.filterCable,
						size: filterSize,
						count: 1,
						selected: filterSize[0],
						diam: this.state.cablesList[0].diameter,
						fullSize: fullSize,
						id: itemList.length
					}
					itemList.push(obj)
					return {itemList, filterCable: 'Выбрать', inputDiam: 0}
				}
			}, () => this.calculatePipeSize())
		} else {
			this.setState(prev => {
				if (this.state.inputDiam !== 0) {
					let filterSize = []
					filterSize.push(this.state.inputDiam)
					let itemList = [...prev.itemList]
					let fullSize = Math.pow(+this.state.inputDiam, 2) * 1 * 3.14 / 4
					let obj = {
						name: "Рассчет по диаметру",
						size: filterSize,
						count: 1,
						selected: filterSize[0],
						diam: this.state.inputDiam,
						fullSize: fullSize,
						id: itemList.length
					}
					itemList.push(obj)
					return {itemList, filterCable: 'Выбрать', inputDiam: 0}
				}
			}, () => {
				this.calculatePipeSize()
			})

		}

	}


	onClickMethodLink(type) {
		if (this.state.method === type) {
			return
		}
		this.setState({method: type, filterCable: 'Выбрать'})
	}

	onSelectCable(value, item) {

		this.setState(prevState => {
			let newBasket = prevState.itemList.map(i => {
				if (i.id === item.id) {
					let diamList = this.db.list.filter((elem) => {
						return (elem.name.trim() === item.name.trim() && elem.size === value)
					})
					i.selected = value
					i.diam = +diamList[0].diameter
					i.fullSize = +diamList[0].diameter * +diamList[0].diameter * i.count * 3.14 / 4
				}


				return i
			})
			return {
				itemList: newBasket
			}

		}, () => {
			this.calculatePipeSize()
			this.onFilterPipeList(this.state.filterList)
		})
	}

	onChangeInputDiam(e) {
		let value = e.target.value
		this.setState({inputDiam: +value})
	}

	calculatePipeSize() {
		let cablesFullSize = this.state.itemList.reduce((acc, current, index, arr) => {
			return acc + arr[index].fullSize
		}, 0)
		let pipeList = this.state.productList.map((i => {
			i.fullSize = Math.pow(+i.diam / 2, 2) * 3.14
			i.percent = (cablesFullSize * 100) / (Math.pow(+i.diam / 2, 2) * 3.14)
			return i
		}))
		let newPipeList = pipeList.filter((i) => {
			return i.percent < 35
		})
		if (this.state.itemList.length == 0) {
			newPipeList = []
			this.setState({newPipeList})
		}
		this.setState({pipeList: newPipeList, newPipeList}, () => {
			this.onFilterPipeList(this.state.filterList)
		})
	}

	onFilterChange(id, value) {
		let filterList = this.state.filterList
		this.setState(prev => {
			let newFilterList = filterList.map((i, index) => {
				if (id == index) {
					if (typeof i.selected == 'boolean') {
						i.selected = !prev.filterList[id].selected
					} else {
						i.selected = value
					}
				}
				return i
			})
			return {filterList: newFilterList}
		}, () => {
			this.onFilterPipeList(this.state.filterList)
		})
	}

	onFilterPipeList(filterList) {
		this.setState((prev) => {
			let newPipeList = [...prev.pipeList]
			if (newPipeList.length == 0) {
				return
			}
			if (this.state.pipe) {
				if (filterList[0].selected !== 'Все') {
					newPipeList = newPipeList.filter((i) => {
						if (filterList[0].selected == 'ПВХ') {
							return i.material.includes(filterList[0].selected)
						} else {
							return !i.material.includes('ПВХ')
						}
					})
				}
				if (filterList[1].selected !== 'Все') {
					newPipeList = newPipeList.filter((i) => {
						return i.name.toLowerCase().includes(filterList[1].selected.toLowerCase())
					})

				}
				if (filterList[2].selected !== 'Все') {
					newPipeList = newPipeList.filter((i) => {
						return i.color.toLowerCase().includes(filterList[2].selected.toLowerCase())
					})
				}
				if (filterList[3].selected) {
					newPipeList = newPipeList.filter((i) => {
						return i.name.toLowerCase().includes('тяжелая')
					})
				}
				if (filterList[4].selected) {
					newPipeList = newPipeList.filter((i) => {
						return i.cablePull.toLowerCase().trim() == 'да'
					})

				}
				if (filterList[5].selected) {
					newPipeList = newPipeList.filter((i) => {
						return i.name.toLowerCase().includes('двустенная')
					})

				}
				if (filterList[6].selected) {
					newPipeList = newPipeList.filter((i) => {
						return i.name.toLowerCase().includes('жесткая')
					})

				}
				if (filterList[7].selected) {
					newPipeList = newPipeList.filter((i) => {
						return i.name.toLowerCase().includes('разборная')
					})
				}

			} else {
				if (filterList[8].selected !== 'Все') {
					newPipeList = newPipeList.filter((i) => {
						return i.material.toLowerCase().includes(filterList[8].selected.toLowerCase())
					})
				}
				if (filterList[9].selected !== 'Все') {
					newPipeList = newPipeList.filter((i) => {
						return i.color.toLowerCase().includes(filterList[9].selected.toLowerCase())
					})
				}
				if (filterList[10].selected) {
					newPipeList = newPipeList.filter((i) => {
						return i.isolation.toLowerCase() !== '-'
					})
				}
				if (filterList[11].selected) {
					newPipeList = newPipeList.filter((i) => {
						return i.cablePull.toLowerCase().trim() == 'да'
					})
				}
			}
			newPipeList = newPipeList.filter(i => {
				return i.percent < 35
			})
			function sortList(a, b) {
				return b.percent - a.percent;
			}
			newPipeList=newPipeList.sort(sortList)
			return {newPipeList}
		})
	}

// -- Обработка печати


	render() {
		let firstLableStyle = ''
		let secondLableStyle = ''
		if (this.state.pipe) {
			firstLableStyle = '#fff'
			secondLableStyle = '#E6EFF1'
		} else if (this.state.flexPipe) {
			firstLableStyle = '#E6EFF1'
			secondLableStyle = '#fff'
		}
		let filterStyle = this.state.pipe ? {
			display: 'grid',
			gridTemplateRows: '20px 20px 20px 20px',
			gridTemplateColumns: '160px 180px',
			maxHeight: '80px',
			width: '440px',
			position: 'absolute',
			zIndex: '100',
			top: "250px",
			left: '20px',
			justifyContent: 'space-evenly',
			gap: '5px'
		} : {
			display: 'grid',
			gridTemplateRows: '20px 20px 20px 20px',
			gridTemplateColumns: '160px 180px',
			maxHeight: '80px',
			width: '440px',
			position: 'absolute',
			zIndex: '100',
			top: "260px",
			left: '20px',
			justifyContent: 'space-evenly',
			gap: '20px 5px'

		}

		return (
			<div className={styles.cfg}>
				{/*Белый фон и лого*/}
				<div style={{position: 'absolute', margin: '0 auto', backgroundColor: '#fff', width: '10%', height: '80px'}}/>
				<Image
					className={styles.logo}
					blockChangeScale={true}
				/>
				{/*Желтый фон заголовка*/}
				<div style={{margin: '0 auto', backgroundColor: '#ffc93a', width: '100%', height: '80px'}}/>
				<div className={styles.title}>Подбор трубы или металлорукава</div>

				{/*Левая часть*/}
				<div style={{position: 'absolute', top: '100px', left: "20px", zIndex: '20'}}>
        	<span
						onClick={this.onPipeCheckChange}
						style={{background: firstLableStyle}}
						className={styles.pipeSectionTitle + ' ' + 'activeTab'}>Подбор трубы</span>
					<span
						onClick={this.onFlexPipeCheckChange}
						style={{background: secondLableStyle}}
						className={styles.flexPipeCableTitle + ' ' + 'activeTab'}>Подбор металлорукава</span>
				</div>

				<div
					style={{
						position: 'absolute',
						left: '30px',
						top: '150px',
						zIndex: '100'
					}}>
					<div className={styles.methodLink} onClick={() => this.onClickMethodLink('mark')}>
						<span style={this.state.method === 'mark' ? {color: '#fecd27', fontSize: '25px'} : {
							color: '#E6EFF1',
							fontSize: '25px'
						}}>&bull;
						</span> Подбор по марке кабеля
					</div>
					<div className={styles.methodLink} onClick={() => this.onClickMethodLink('diam')}>
						<span style={this.state.method === 'diam' ? {color: '#fecd27', fontSize: '25px'} : {
							color: '#E6EFF1',
							fontSize: '25px'
						}}>&bull;
						</span> Подбор по диаметру кабеля
					</div>
					{this.state.method === 'mark' ? <DropDown
						type='cable'
						x={260}
						y={5}
						key='cable'
						app={this}/> : <div style={{
						display: 'flex',
						position: 'absolute',
						top: '22px',
						left: '260px',
					}}><input type={"number"} step={'0.01'} style={{
						width: '140px',
						height: '21px'
					}} defaultValue={this.state.inputDiam}
										onBlur={e => this.onChangeInputDiam(e)}/><span style={{padding: '4px'}}>мм</span></div>}
				</div>


				<div>
					<div style={{
						position: 'absolute',
						backgroundColor: '#ffffff',
						left: '20px',
						width: '440px',
						height: '250px',
						top: '100px',
						zIndex: '1'
					}}/>

					{(this.state.pipe || this.state.flexPipe) &&
						<div style={filterStyle}>
							{this.state.filterList.map((i, id) => {
								let show = this.state.pipe ? i.show : !i.show
								if (show) {
									return (<div key={id+'filter'} style={{
										display: 'grid',
										gridTemplateColumns: '80px 100px',
										alignItems: 'center'
									}}>
										<div>{i.name}</div>
										{typeof (i.selected) == 'boolean' ?
											<Switch onChange={this.onFilterChange} id={id} value={i.selected}/>
											:
											<select defaultValue={i.selected} onChange={e => this.onFilterChange(id, e.target.value)}>
												{i.value.length > 0 ? i.value.map((item,index) => {
													return (<option key={id+index+'option'} value={item}>{item}</option>)
												}) : <option value="Все">Все</option>}
											</select>
										}
									</div>)
								}
							})}
						</div>}


					<Table
						title='ЗАПОЛНЕНИЕ'
						type='Cable'
						items={this.state.itemList}
						styles={{
							width: '440px',
							height: '130px',
							top: '360px',
							left: '20px',
							fontSize: '12px'
						}}
						onChangeQuantity={this.onChangeQuantity}
						onSelectCable={this.onSelectCable}
						onDelete={this.onDelete}
						itemInfo={this.state.item}
						configType='pipe'
					/>


					{/*Спецификация*/}
					<Table
						title='ПОДОБРАННЫЕ РЕШЕНИЯ'
						type='pipe'
						items={this.state.newPipeList ? this.state.newPipeList : this.state.pipeList}
						styles={{
							width: '440px',
							height: '200px',
							top: '550px',
							left: '20px',
							fontSize: '12px'
						}}
						onSelect={this.onListItemCheck}
						addBasket={this.addBasket}
						itemInfo={this.state.item}
						configType='pipe'
					/>
				</div>


				{/*Середина*/}
				{/*Корзина*/}
				{
					<Table
						title='КОРЗИНА'
						type='Bucket'
						items={this.state.bucketPipeList}
						styles={{width: '440px', height: '552px', top: '100px', left: '480px', fontSize: '12px'}}
						onSelect={this.onListItemCheck}
						onDelete={this.onDelete}
						onChangeQuantity={this.onChangeQuantity}
						totalPrice={this.calcTotalPrice()}
						configType='pipe'
					/>}

				{/*Правая часть*/}
				{/* Артикул и имя */}
				<div className={styles.itemInfoBG}/>
				{this.state.item && this.state.item[0] ? (
					<a href={`https://www.iek.ru/products/catalog/?page=detail&article=${this.state.item[0].art}`}
						 target="_blank">
						<div className={styles.itemInfo}>
							<div className={styles.itemInfo_Article}>{this.state.item[0].art}</div>
							<div>{this.state.item[0].name}</div>
						</div>
					</a>
				) : (
					<div className={styles.itemInfoNoArticle}/>
				)}

				{/* Фото */}
				<Image
					className={styles.itemImg}
					url={this.state.item && this.state.item[0] && this.state.item[0].ImgPng[0].file_ref.uri ? this.state.item[0].ImgPng[0].file_ref.uri : null}
				/>


				{/* Описание */}
				<div style={{
					position: 'absolute',
					top: '452px',
					left: '940px',
					backgroundColor: '#fff',
					width: '434px',
					height: '292px'
				}}/>
				{this.state.item && this.state.item[0] && this.state.item[0].Description[0].desc_ru ? (
					<div className={styles.description}>
						{this.state.item[0].Description[0].desc_ru}
					</div>
				) : (
					<div className={styles.descriptionEmpty}>
					</div>
				)}


				{/*Кнопки*/}
				{this.getCustomButtons ? this.getCustomButtons() : null}

				{/*Нижняя плашка*/}
				{/* На основной сайт IEK */}
				<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '50%', height: '20px', top: '820px'}}/>
				<a className={styles.homeLink} href={'https://www.iek.ru/'} target="_blank">На основной сайт IEK</a>

				{/* Техническая поддержка */}
				<div style={{
					position: 'absolute',
					backgroundColor: '#ffc93a',
					width: '50%',
					height: '20px',
					top: '820px',
					left: '700px'
				}}/>
				<a style={{
					position: 'absolute',
					top: '823px',
					left: '415px',
					color: '#37424a',
					width: '141px',
					height: '14px'
				}} href={'https://www.iek.ru/support/techsupport/'} target="_blank">Техническая поддержка:
				</a>
				<span className={styles.techSupport}>+7 (495) 542-22-27</span>
			</div>
		)
	}
}

export default PipeConfigurator;


class DropDown extends React.Component {

	render() {

		let typeCap = this.props.app.capitalizeFirstLetter(this.props.type)

		return <div>
			<span className={styles.selectLabel}
						style={{top: this.props.y + 'px', left: this.props.x + 'px'}}>{this.props.header}</span>
			<select
				className={styles.selectBase}
				style={{top: this.props.y + 17 + 'px', left: this.props.x + 'px'}}
				onChange={this.props.app['on' + typeCap + 'Change']}
				value={this.props.app.state['filter' + typeCap]}
			> {this.props.app.state[this.props.type + 'Options'].length > 0
				? this.props.app.state[this.props.type + 'Options'].map((option, index) => {
					return (
						<option value={option} key={index + option}>{option} </option>)
				})
				: <option value="Выбрать">Выбрать</option>
			}
			</select>
		</div>
	}

}





// WEBPACK FOOTER //
// ./src/react/PipeConfigurator.jsx